import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { MdArrowBack } from 'react-icons/md';

const ResultadoSimulacion = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { simulacionData, idCotizacion } = location.state || {};
  const [pdfMakeLoaded, setPdfMakeLoaded] = useState(false);

  useEffect(() => {
    // Función para cargar scripts dinámicamente
    const loadScript = (src) => {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
      });
    };

    // Verificar si pdfMake ya está cargado
    if (window.pdfMake) {
      setPdfMakeLoaded(true);
      return;
    }

    // Cargar pdfMake y vfs_fonts
    const loadPdfMake = async () => {
      try {
        await loadScript('https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/pdfmake.min.js');
        await loadScript('https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/vfs_fonts.min.js');
        setPdfMakeLoaded(true);
        console.log('pdfMake cargado exitosamente');
      } catch (error) {
        console.error('Error al cargar pdfMake:', error);
      }
    };

    loadPdfMake();
  }, []);

  if (!simulacionData) {
    console.log('No hay datos de simulación en location.state:', location.state);
    return (
      <div className="panel-container">
        <div className="panel-header">
          <h1 className="panel-title">Resultado de Simulación</h1>
        </div>
        <div className="text-center text-red-600">
          No hay datos de simulación disponibles
        </div>
      </div>
    );
  }

  console.log('Datos de simulación recibidos:', simulacionData);

  const { detalle_documentos, resumen_operacion } = simulacionData;
  const resumen = resumen_operacion[0];

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: 'CLP',
      minimumFractionDigits: 0
    }).format(value);
  };

  const formatCurrencySimple = (value) => {
    return new Intl.NumberFormat('es-CL', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(value);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('es-CL');
  };

  const imageToBase64 = (url) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        const dataURL = canvas.toDataURL('image/png');
        resolve(dataURL);
      };
      img.onerror = reject;
      img.src = url;
    });
  };

  const generatePDF = async () => {
    // Verificar que pdfMake esté disponible
    if (!window.pdfMake || !pdfMakeLoaded) {
      alert('pdfMake se está cargando. Por favor, espera un momento e intenta nuevamente.');
      return;
    }

    try {
      // Cargar imágenes y convertirlas a base64
      const headerBase64 = await imageToBase64('/img/logo-interfactor.png');
      const footerBase64 = await imageToBase64('/img/interfactor-footer.png');

      // Calcular totales
      const montoTotalFacturas = detalle_documentos.reduce((sum, doc) => sum + doc.MONTO_FACTURA, 0);

      // Construir tabla de documentos
      const tablaDocumentos = [
        // Encabezado
        [
          { text: 'N° de\nFactura', bold: true, alignment: 'left', borderColor: ['#D60B13', '#FFFFFF', '#FFFFFF', '#FFFFFF'], fillColor: '#F6F6F6' },
          { text: 'Deudor', bold: true, alignment: 'left', borderColor: ['#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF'], fillColor: '#F6F6F6' },
          { text: 'Fecha de\nLiberación', bold: true, alignment: 'left', borderColor: ['#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF'], fillColor: '#F6F6F6' },
          { text: 'Monto Factura', bold: true, alignment: 'left', borderColor: ['#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF'], fillColor: '#F6F6F6' },
          { text: 'Monto a Financiar', bold: true, alignment: 'left', borderColor: ['#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF'], fillColor: '#F6F6F6' },
          { text: 'Tasa', bold: true, alignment: 'left', borderColor: ['#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF'], fillColor: '#F6F6F6' },
          { text: 'Diferencia de\nPrecio', bold: true, alignment: 'left', borderColor: ['#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF'], fillColor: '#F6F6F6' }
        ]
      ];

      // Agregar filas de documentos
      detalle_documentos.forEach(doc => {
        tablaDocumentos.push([
          { text: doc.NUM_FACTURA, bold: true, alignment: 'right', borderColor: ['#D60B13', '#F6F6F6', '#F6F6F6', '#F6F6F6'] },
          { text: doc.DEUDOR, bold: true, alignment: 'left', borderColor: ['#F6F6F6', '#F6F6F6', '#F6F6F6', '#F6F6F6'] },
          { text: formatDate(doc.VENCIMIENTO_FINAL), bold: true, alignment: 'center', borderColor: ['#F6F6F6', '#F6F6F6', '#F6F6F6', '#F6F6F6'] },
          { text: `$ ${formatCurrencySimple(doc.MONTO_FACTURA)}`, bold: true, alignment: 'right', borderColor: ['#F6F6F6', '#F6F6F6', '#F6F6F6', '#F6F6F6'] },
          { text: `$ ${formatCurrencySimple(doc.MONTO_FINANCIAR)}`, bold: true, alignment: 'right', borderColor: ['#F6F6F6', '#F6F6F6', '#F6F6F6', '#F6F6F6'] },
          { text: `${doc.TASA}%`, bold: true, alignment: 'center', borderColor: ['#F6F6F6', '#F6F6F6', '#F6F6F6', '#F6F6F6'] },
          { text: `$ ${formatCurrencySimple(doc.DIF_PRECIO)}`, bold: true, alignment: 'right', borderColor: ['#F6F6F6', '#F6F6F6', '#F6F6F6', '#F6F6F6'] }
        ]);
      });

      const docDefinition = {
        pageSize: 'A4',
        pageMargins: [30, 100, 30, 90],
        background: function(currentPage, pageSize) {
          return {
            image: footerBase64,
            alignment: 'center',
            width: pageSize.width,
            absolutePosition: { x: 0, y: pageSize.height - 120 },
            opacity: 0.9
          };
        },
        header: function(currentPage, pageCount) {
          return {
            image: headerBase64,
            alignment: 'center',
            width: 600,
            margin: [0, 0, 0, 0]
          };
        },
        content: [
          { text: 'SIMULACIÓN DE OPERACIÓN', style: 'header' },
          { text: 'Datos', style: 'subheader' },
          {
            style: 'tableDatos',
            table: {
              widths: ['50%', '50%'],
              body: [
                [
                  { text: 'Cliente', bold: true, borderColor: ['#D60B13', '#FFFFFF', '#FFFFFF', '#FFFFFF'], fillColor: '#F6F6F6' },
                  { text: resumen.NOMBRE_CLIENTE, borderColor: ['#D60B13', '#FFFFFF', '#FFFFFF', '#FFFFFF'], fillColor: '#F6F6F6' }
                ],
                [
                  { text: 'Rut', bold: true, borderColor: ['#D60B13', '#FFFFFF', '#FFFFFF', '#FFFFFF'], fillColor: '#F6F6F6' },
                  { text: resumen.RUT_CLIENTE, borderColor: ['#D60B13', '#FFFFFF', '#FFFFFF', '#FFFFFF'], fillColor: '#F6F6F6' }
                ],
                [
                  { text: 'Fecha Operación', bold: true, borderColor: ['#D60B13', '#FFFFFF', '#FFFFFF', '#FFFFFF'], fillColor: '#F6F6F6' },
                  { text: formatDate(resumen.FECHA_OPE), borderColor: ['#D60B13', '#FFFFFF', '#FFFFFF', '#FFFFFF'], fillColor: '#F6F6F6' }
                ],
                [
                  { text: 'Fecha Simulación', bold: true, borderColor: ['#D60B13', '#FFFFFF', '#FFFFFF', '#FFFFFF'], fillColor: '#F6F6F6' },
                  { text: formatDate(resumen.FECHA_SIMULACION), borderColor: ['#D60B13', '#FFFFFF', '#FFFFFF', '#FFFFFF'], fillColor: '#F6F6F6' }
                ]
              ]
            }
          },
          {
            style: 'tableRes',
            table: {
              widths: ['20%', '18%', '12%', '10%', '20%', '20%'],
              body: [
                [
                  { text: 'Monto Documentos:', bold: true, border: [false, false, false, false], margin: [0, 0, 0, 0] },
                  { text: `$ ${formatCurrencySimple(montoTotalFacturas)}`, border: [false, false, false, false], fillColor: '#F6F6F6' },
                  { text: '% Anticipo:', bold: true, alignment: 'right', border: [false, false, false, false] },
                  { text: `${resumen.ANTICIPO}%`, border: [false, false, false, false], fillColor: '#F6F6F6' },
                  { text: 'Monto Anticipado:', bold: true, alignment: 'right', border: [false, false, false, false] },
                  { text: `$ ${formatCurrencySimple(resumen.MONTO_ANTICIPADO)}`, border: [false, false, false, false], fillColor: '#F6F6F6' }
                ]
              ]
            }
          },
          { text: 'Resumen Simulación', style: 'subheader' },
          {
            style: 'tableDatos',
            table: {
              widths: ['50%', '50%'],
              body: [
                [
                  { text: 'Monto Anticipado:', bold: true, borderColor: ['#D60B13', '#FFFFFF', '#FFFFFF', '#FFFFFF'], fillColor: '#F6F6F6' },
                  { text: `$ ${formatCurrencySimple(resumen.MONTO_ANTICIPADO)}`, borderColor: ['#D60B13', '#FFFFFF', '#FFFFFF', '#FFFFFF'], fillColor: '#F6F6F6' }
                ],
                [
                  { text: 'Diferencia de Precio:', bold: true, borderColor: ['#D60B13', '#FFFFFF', '#FFFFFF', '#FFFFFF'], fillColor: '#F6F6F6' },
                  { text: `$ ${formatCurrencySimple(resumen.DIF_PRECIO)}`, borderColor: ['#D60B13', '#FFFFFF', '#FFFFFF', '#FFFFFF'], fillColor: '#F6F6F6' }
                ],
                [
                  { text: 'Gastos', bold: true, borderColor: ['#D60B13', '#FFFFFF', '#FFFFFF', '#FFFFFF'], fillColor: '#F6F6F6' },
                  { text: `$ ${formatCurrencySimple(resumen.GASTOS)}`, borderColor: ['#D60B13', '#FFFFFF', '#FFFFFF', '#FFFFFF'], fillColor: '#F6F6F6' }
                ],
                [
                  { text: 'Comisiones', bold: true, borderColor: ['#D60B13', '#FFFFFF', '#FFFFFF', '#FFFFFF'], fillColor: '#F6F6F6' },
                  { text: `$ ${formatCurrencySimple(resumen.COMISION)}`, borderColor: ['#D60B13', '#FFFFFF', '#FFFFFF', '#FFFFFF'], fillColor: '#F6F6F6' }
                ],
                [
                  { text: 'IVA Gastos y Comisiones:', bold: true, borderColor: ['#D60B13', '#FFFFFF', '#FFFFFF', '#FFFFFF'], fillColor: '#F6F6F6' },
                  { text: `$ ${formatCurrencySimple(resumen.IVA)}`, borderColor: ['#D60B13', '#FFFFFF', '#FFFFFF', '#FFFFFF'], fillColor: '#F6F6F6' }
                ],
                [
                  { text: 'MONTO A GIRO', bold: true, borderColor: ['#D60B13', '#FFFFFF', '#FFFFFF', '#FFFFFF'], fillColor: '#F6F6F6' },
                  { text: `$ ${formatCurrencySimple(resumen.TOTAL_GIRAR)}`, bold: true, borderColor: ['#D60B13', '#FFFFFF', '#FFFFFF', '#FFFFFF'], fillColor: '#F6F6F6' }
                ]
              ]
            }
          },
          { text: 'Detalle de Documentos', style: 'subheader' },
          {
            style: 'table_doc',
            table: {
              widths: ['8%', '28%', '12%', '14%', '14%', '8%', '16%'],
              body: tablaDocumentos
            },
            layout: {
              paddingLeft: () => 4,
              paddingRight: () => 4,
              paddingTop: () => 2,
              paddingBottom: () => 2
            }
          },
          { text: 'El otorgamiento de la operación queda sujeto a la aprobación y verificación de antecedentes.', style: 'footer' }
        ],

        styles: {
          header: {
            fontSize: 16,
            bold: true,
            margin: [0, 0, 0, 20],
            color: '#304251'
          },
          subheader: {
            fontSize: 14,
            bold: true,
            margin: [0, 10, 0, 10],
            color: '#304251'
          },
          footer: {
            fontSize: 8,
            italics: true,
            margin: [0, 0, 0, 10],
            color: '#304251'
          },
          tableRes: {
            fontSize: 10,
            margin: [5, 0, 0, 15],
            color: '#304251'
          },
          tableExample: {
            fontSize: 12,
            margin: [0, 0, 0, 15],
            color: '#304251'
          },
          tableDatos: {
            fontSize: 10,
            margin: [0, 0, 0, 15],
            color: '#304251'
          },
          table_doc: {
            fontSize: 8,
            margin: [0, 0, 0, 10],
            color: '#304251'
          }
        }
      };

      // Generar y descargar el PDF usando window.pdfMake
      window.pdfMake.createPdf(docDefinition).download(`Simulacion_Operacion_${idCotizacion}.pdf`);
    } catch (error) {
      console.error('Error al generar el PDF:', error);
      alert('Error al generar el PDF. Verifique que las imágenes existan en la carpeta public/img/');
    }
  };

  return (
    <div className="p-6">
      <div className="flex items-baseline gap-4 mb-6">
        <h1 className="text-2xl font-bold text-gray-800">Simulación de operación</h1>
        <p className="text-gray-600">ID Cotización: {idCotizacion}</p>
      </div>

      <div className="mb-4 flex gap-4">
        <button
          onClick={generatePDF}
          className="btn-primary flex items-center gap-2"
          disabled={!pdfMakeLoaded}
        >
          {pdfMakeLoaded ? 'Descargar PDF' : 'Cargando...'}
        </button>
      </div>

      <div className="seccion-datos mb-6">
        <h3 style={{color: 'var(--if-primary)', margin: '0 0 1rem 0', fontSize: '1.2rem', fontWeight: '600'}}>
          Datos
        </h3>
          
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="flex items-center gap-2 text-sm font-medium">
              <span>Nombre Cliente:</span>
              <span className="text-lg font-bold text-gray-900">
                {resumen.NOMBRE_CLIENTE}
              </span>
            </label>
          </div>

          <div>
            <label className="flex items-center gap-2 text-sm font-medium">
              <span>RUT Cliente:</span>
              <span className="text-lg font-bold text-gray-900">
                {resumen.RUT_CLIENTE}
              </span>
            </label>
          </div>

          <div>
            <label className="flex items-center gap-2 text-sm font-medium">
              <span>Fecha Operación:</span>
              <span className="text-sm font-bold text-gray-900">
                {formatDate(resumen.FECHA_OPE)}
              </span>
            </label>
          </div>

          <div>
            <label className="flex items-center gap-2 text-sm font-medium">
              <span>Fecha Simulación:</span>
              <span className="text-sm font-bold text-gray-900">
                {formatDate(resumen.FECHA_SIMULACION)}
              </span>
            </label>
          </div>

        </div>
      </div>

      <div className="seccion-datos mb-6">
        <h3 style={{color: 'var(--if-primary)', margin: '0 0 1rem 0', fontSize: '1.2rem', fontWeight: '600'}}>
          Valores Totales
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="flex items-center gap-2 text-sm font-medium">
              <span>Monto Total de Facturas:</span>
              <span className="text-lg font-bold text-gray-900">
                {formatCurrency(detalle_documentos.reduce((sum, doc) => sum + doc.MONTO_FACTURA, 0))}
              </span>
            </label>
          </div>

          <div>
            <label className="flex items-center gap-2 text-sm font-medium">
              <span>Anticipo</span>
              <span className="text-lg font-bold text-gray-900">
                {resumen.ANTICIPO}%
              </span>
            </label>
          </div>

          <div>
            <label className="flex items-center gap-2 text-sm font-medium">
              <span>Monto Anticipado:</span>
              <span className="text-lg font-bold text-gray-900">
                {formatCurrency(resumen.MONTO_ANTICIPADO)}
              </span>
            </label>
          </div>
        </div>
      </div>

      <div className="seccion-datos mb-6">
        <h3 style={{color: 'var(--if-primary)', margin: '0 0 1rem 0', fontSize: '1.2rem', fontWeight: '600'}}>
          Resumen Simulación
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="flex items-center gap-2 text-sm font-medium">
              <span>Diferencia de Precio:</span>
              <span className="text-lg font-bold text-gray-900">
                {formatCurrency(resumen.DIF_PRECIO)}
              </span>
            </label>
          </div>

          <div>
            <label className="flex items-center gap-2 text-sm font-medium">
              <span>Gastos:</span>
              <span className="text-lg font-bold text-gray-900">
                {formatCurrency(resumen.GASTOS)}
              </span>
            </label>
          </div>

          <div>
            <label className="flex items-center gap-2 text-sm font-medium">
              <span>Comisión:</span>
              <span className="text-lg font-bold text-gray-900">
                {formatCurrency(resumen.COMISION)}
              </span>
            </label>
          </div>

          <div>
            <label className="flex items-center gap-2 text-sm font-medium">
              <span>IVA:</span>
              <span className="text-lg font-bold text-gray-900">
                {formatCurrency(resumen.IVA)}
              </span>
            </label>
          </div>

          <div>
            <label className="flex items-center gap-2 text-sm font-medium">
              <span>Total a Girar:</span>
              <span className="text-lg font-bold text-gray-900">
                {formatCurrency(resumen.TOTAL_GIRAR)}
              </span>
            </label>
          </div>
        </div>
      </div>

      {/* Detalle de Documentos */}
      <div className="seccion-datos">
        <h3 style={{color: 'var(--if-primary)', margin: '0 0 1rem 0', fontSize: '1.2rem', fontWeight: '600'}}>
          Detalle de Documentos
        </h3>
        
        <div className="tabla-container">
          <table className="w-full" style={{fontSize: '0.875rem'}}>
            <thead>
              <tr>
                <th>N° Factura</th>
                <th>Deudor</th>
                <th>Vencimiento Final</th>
                <th>Monto Factura</th>
                <th>Monto a Financiar</th>
                <th>Tasa (%)</th>
                <th>Diferencia de Precio</th>
              </tr>
            </thead>
            <tbody>
              {detalle_documentos.map((doc, index) => (
                <tr key={index}>
                  <td>{doc.NUM_FACTURA}</td>
                  <td>{doc.DEUDOR}</td>
                  <td>{formatDate(doc.VENCIMIENTO_FINAL)}</td>
                  <td style={{textAlign: 'right'}}>{formatCurrency(doc.MONTO_FACTURA)}</td>
                  <td style={{textAlign: 'right'}}>{formatCurrency(doc.MONTO_FINANCIAR)}</td>
                  <td style={{textAlign: 'center'}}>{doc.TASA}%</td>
                  <td style={{textAlign: 'right'}}>{formatCurrency(doc.DIF_PRECIO)}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr style={{borderTop: '2px solid #374151', fontWeight: '600'}}>
                <td colSpan="3" style={{textAlign: 'right'}}>TOTALES:</td>
                <td style={{textAlign: 'right'}}>
                  {formatCurrency(detalle_documentos.reduce((sum, doc) => sum + doc.MONTO_FACTURA, 0))}
                </td>
                <td style={{textAlign: 'right'}}>
                  {formatCurrency(detalle_documentos.reduce((sum, doc) => sum + doc.MONTO_FINANCIAR, 0))}
                </td>
                <td></td>
                <td style={{textAlign: 'right'}}>
                  {formatCurrency(detalle_documentos.reduce((sum, doc) => sum + doc.DIF_PRECIO, 0))}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ResultadoSimulacion;